(function () {
  const SELECTOR = "[data-roi-calculator]";

  function parseConfig(node) {
    try {
      return JSON.parse(node.dataset.config || "{}");
    } catch (error) {
      console.error("ROI calculator config parsing failed", error);
      return {};
    }
  }

  function toNumber(value, fallback) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function divide(numerator, denominator) {
    return denominator ? numerator / denominator : 0;
  }

  function calculateScenario(inputs, yieldLift) {
    const addedYieldPerSqFt = inputs.baselineYield * yieldLift;
    const addedRevenuePerSqFt = addedYieldPerSqFt * inputs.wholesalePrice;
    const costPerSqFtPerCycle = inputs.mammothCost;
    const roiMultiple = divide(addedRevenuePerSqFt, costPerSqFtPerCycle);
    const roiPercent = divide(addedRevenuePerSqFt - costPerSqFtPerCycle, costPerSqFtPerCycle);
    const cycleRevenueImpact = addedRevenuePerSqFt * inputs.facilitySize;
    const annualNetProfitImpact =
      (cycleRevenueImpact - costPerSqFtPerCycle * inputs.facilitySize) *
      inputs.cyclesPerYear;

    return {
      yieldLift,
      addedYieldPerSqFt,
      addedRevenuePerSqFt,
      costPerSqFtPerCycle,
      roiMultiple,
      roiPercent,
      cycleRevenueImpact,
      annualNetProfitImpact
    };
  }

  function calculateKeyOutputs(inputs) {
    const base = calculateScenario(inputs, inputs.selectedYieldLift);
    const addedRevenuePerCycle = base.addedRevenuePerSqFt * inputs.facilitySize;
    const addedCostPerCycle = inputs.mammothCost * inputs.facilitySize;
    const netProfitPerCycle = addedRevenuePerCycle - addedCostPerCycle;
    const annualNetProfitImpact = netProfitPerCycle * inputs.cyclesPerYear;

    return {
      ...base,
      addedRevenuePerCycle,
      addedCostPerCycle,
      netProfitPerCycle,
      annualNetProfitImpact
    };
  }

  function formatNumber(value, digits) {
    return new Intl.NumberFormat(undefined, {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits
    }).format(value);
  }

function formatCurrency(value, currency) {
  return new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency || "USD",
    // Setting minimum to 0 removes .00
    minimumFractionDigits: value % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2
  }).format(value);
}

  function formatPercent(value) {
    return new Intl.NumberFormat(undefined, {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  }

  function formatEditablePercent(value) {
    return Number((value * 100).toFixed(2)).toString();
  }

  function isSameLift(left, right) {
    return Math.abs(left - right) < 0.0001;
  }

  function renderOutputs(root, inputs) {
    const keyOutputs = calculateKeyOutputs(inputs);
    const rows = inputs.scenarioLifts.map((yieldLift) => calculateScenario(inputs, yieldLift));

    const outputMap = {
      addedYieldPerSqFt: `${formatNumber(keyOutputs.addedYieldPerSqFt, 2)}`,
      addedRevenuePerSqFt: formatCurrency(keyOutputs.addedRevenuePerSqFt, inputs.currency),
      roiMultiple: `${formatNumber(keyOutputs.roiMultiple, 1)}x`,
      roiPercent: formatPercent(keyOutputs.roiPercent),
      addedRevenuePerCycle: formatCurrency(keyOutputs.addedRevenuePerCycle, inputs.currency),
      addedCostPerCycle: formatCurrency(keyOutputs.addedCostPerCycle, inputs.currency),
      netProfitPerCycle: formatCurrency(keyOutputs.netProfitPerCycle, inputs.currency),
      annualNetProfitImpact: formatCurrency(keyOutputs.annualNetProfitImpact, inputs.currency)
    };

    Object.entries(outputMap).forEach(([key, value]) => {
      const target = root.querySelector(`[data-output="${key}"]`);
      if (target) {
        target.textContent = value;
      }
    });

    const tbody = root.querySelector('[data-output="scenarioRows"]');
    if (tbody) {
      tbody.innerHTML = rows
        .map(
          (row) => `
            <tr class="${isSameLift(row.yieldLift, inputs.selectedYieldLift) ? "is-active" : ""}">
              <td>${formatPercent(row.yieldLift)}</td>
              <!--<td>${formatNumber(row.addedYieldPerSqFt, 2)}</td>-->
              <td>${formatCurrency(row.addedRevenuePerSqFt, inputs.currency)}</td>
              <!--<td>${formatCurrency(row.costPerSqFtPerCycle, inputs.currency)}</td>-->
              <td>${formatNumber(row.roiMultiple, 1)}x</td>
              <!--<td>${formatPercent(row.roiPercent)}</td>-->
              <td>${formatCurrency(row.cycleRevenueImpact, inputs.currency)}</td>
              <td>${formatCurrency(row.annualNetProfitImpact, inputs.currency)}</td>
            </tr>
          `
        )
        .join("");
    }

    root.querySelectorAll("[data-yield-lift]").forEach((button) => {
      const isActive = toNumber(button.dataset.yieldLift, 0) === inputs.selectedYieldLift;
      button.classList.toggle("is-active", isActive);
    });

    root.querySelectorAll('[data-percent-input="selectedYieldLift"]').forEach((field) => {
      field.value = formatEditablePercent(inputs.selectedYieldLift);
    });
  }

  function bindCalculator(root) {
    const config = parseConfig(root);
    const inputs = {
      baselineYield: toNumber(config.baselineYield, 70),
      wholesalePrice: toNumber(config.wholesalePrice, 1.2),
      mammothCost: toNumber(config.mammothCost, 0.075),
      facilitySize: toNumber(config.facilitySize, 10000),
      cyclesPerYear: toNumber(config.cyclesPerYear, 6),
      selectedYieldLift: toNumber(config.selectedYieldLift, 0.05),
      scenarioLifts: Array.isArray(config.scenarioLifts)
        ? config.scenarioLifts.map((value) => toNumber(value, 0)).filter(Boolean)
        : [0.2, 0.16, 0.1, 0.05, 0.01],
      currency: config.currency || "USD"
    };

    root.querySelectorAll("[data-input]").forEach((field) => {
      field.addEventListener("input", function () {
        const key = field.dataset.input;
        inputs[key] = toNumber(field.value, inputs[key]);
        renderOutputs(root, inputs);
      });
    });

    root.querySelectorAll("[data-percent-input]").forEach((field) => {
      field.addEventListener("input", function () {
        const key = field.dataset.percentInput;
        inputs[key] = toNumber(field.value, inputs[key] * 100) / 100;
        renderOutputs(root, inputs);
      });
    });

    root.querySelectorAll("[data-yield-lift]").forEach((button) => {
      button.addEventListener("click", function () {
        inputs.selectedYieldLift = toNumber(button.dataset.yieldLift, inputs.selectedYieldLift);
        renderOutputs(root, inputs);
      });
    });

    renderOutputs(root, inputs);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(bindCalculator);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();